const initialState = {
  data: [],
};

const finishOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_FINISH_ORDER": {
      return {
        data: action.payload,
      };
    }

    case "PUSH_BEFORE_FINISH_ORDER": {
      const data = state.data;
      const payload = action.payload;

      const indexItem = data.findIndex((i) => i.id === payload.id);

      if (indexItem !== -1) {
        return { data };
      }

      return {
        data: [payload, ...data],
      };
    }

    default:
      return state;
  }
};

export default finishOrderReducer;
